module.exports = __webpack_public_path__ + "static/57-1e22eb7b72e62c1a5b674a3dee2e6510.png";